export const request = async (url, method, body = null, customHeaders = {}, credentials = 'include') => {

    const isFormData = body instanceof FormData;

    const headers = {
        'Accept': 'application/json',
        ...customHeaders
    };

    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
    }

    const options = {
        method,
        headers,
        credentials
    };

    if (method !== 'GET' && body) {
        options.body = isFormData ? body : JSON.stringify(body);
    }

    try {
        const response = await fetch(url, options);

        if (!response.ok) {
            let errorData = null;

            try {
                errorData = await response.json();
            } catch (_) {
                errorData = null;
            }

            console.log("Error details", errorData);

            if (response.status === 401) {
                return Promise.reject({ message: "TokenExpired", status: 401 });
            }

            return Promise.reject({
                status: response.status,
                message: errorData?.message || response.statusText || "Ошибка запроса",
                ...errorData,
            });
        }

        return await response.json();

    } catch (e) {
        console.error("Fetch error:", e);
        throw e;
    }
};